import { render, staticRenderFns } from "./QuickNewUser.vue?vue&type=template&id=180404f2"
import script from "./QuickNewUser.vue?vue&type=script&lang=js"
export * from "./QuickNewUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports